import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductAnalysisGroup3 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group3-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAnalysisGroup3Request } from 'src/app/assabil-kernel/models/dtos/control-tables/product-analysis-group3-request';


@Component({
  selector: 'app-product-analysis-group3-list',
  templateUrl: './product-analysis-group3-list.component.html',
  styleUrls: ['./product-analysis-group3-list.component.scss']
})
export class ProductAnalysisGroup3ListComponent extends BasePage2<ProductAnalysisGroup3> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productsAnalysisGroups: ProductAnalysisGroup3[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);
                          
      this.entityName  = 'productAnalysisGroup3';
  }


  listFields = [
      { prop: 'productAnalysisGroup3Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  //----------------------------------------------------------------------
  getRows(): ProductAnalysisGroup3[] {
      return this.productsAnalysisGroups;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : ProductAnalysisGroup3 = new ProductAnalysisGroup3();
    entity.inserted = true;
    entity.edit = true;
    this.productsAnalysisGroups.push(entity);
    this.productsAnalysisGroups = [...this.productsAnalysisGroups];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  saveRow(productAnalysisGroup3: ProductAnalysisGroup3): Promise<ProductAnalysisGroup3> {
    let request  : ProductAnalysisGroup3Request = new ProductAnalysisGroup3Request(this.controlService.getUserInfo());
    request.productAnalysisGroup3 = productAnalysisGroup3;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.productsAnalysisGroups = result;
        
    }); 
  }
//----------------------------------------------------------------------

  }
